var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconOtherWallet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a",
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2514.567 -1457.127)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.13,240.149l10.906-9.8,24.571,23.511c7.019-6.784,13.9-13.121,20.339-19.867,3.243-3.387,5.524-3.3,8.536.059,6.137,6.843,12.483,13.5,19.276,20.8L179.3,230.4c3.387,3,7.766,7.037,10.913,9.818-.266.291-.76.672-1.2,1.12l-34.142,32.919-24.709-25.613-24.606,25.647c-6.534-6.568-12.939-13.28-19.592-19.733C80.839,249.589,75.406,244.966,70.13,240.149Z",
    transform: "translate(2448.396 1282.712)",
    fill: "#13155e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.036,168.929l-9.346-9.974s14.272-18.088,37.532-17.5c26.329-.353,38.411,18.428,38.411,18.428l-9.5,9.042s-11.419-14.456-27.683-14.456C162.731,154.473,150.036,168.929,150.036,168.929Z",
    transform: "translate(2399.905 1343.81)",
    fill: "#13155e"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOtherWallet);
export default __webpack_public_path__ + "static/media/icon-other-wallet.77bbaeb43265dc6d9a73c5efac9cd321.svg";
export { ForwardRef as ReactComponent };